<template>
  <div>
    <el-input
      v-if="type === 'input'"
      v-model="form.value"
      @input="$emit('input', $event)"
    >
    </el-input>
    <div
      v-if="type === 'currency'"
      class=" el-input"
      style="width: 200px"
    >
      <CurrencyInput
        :currency="{'prefix' : ''}"
        v-model="form.value"
        @input="$emit('input', $event)"
        locale="pt-BR"
        class="el-input__inner"
      />
    </div>
    <div
      v-if="type === 'number'"
      class=" el-input"
      style="width: 200px"
    >
      <CurrencyInput
        :currency="{'prefix' : ''}"
        :precision="0"
        :value-as-integer="true"
        v-model="form.value"
        @input="$emit('input', $event)"
        locale="pt-BR"
        class="el-input__inner"
      />
    </div>
    <el-date-picker
      v-if="type === 'date'"
      format="dd/MM/yyyy"
      :value-format="config.valueFormat"
      @change="$emit('input', $event)"
      v-model="form.value"
    >
    </el-date-picker>
    <el-date-picker
      v-if="type === 'daterange'"
      type="daterange"
      format="dd/MM/yyyy"
      :value-format="config.valueFormat"
      range-separator="a"
      @change="$emit('input', $event)"
      v-model="form.value"
    >
    </el-date-picker>
    <el-select
      v-if="type === 'select' && config.hasOwnProperty('items') "
      v-model="form.value"
      filterable
      :placeholder="config.placeholder"
      :primary-key="config.primarykey"
      :label="config.label"
      @input="$emit('input', $event)"
      :value-key="config.primarykey"
    >
      <el-option
        v-for="(value , key ) in config.items"
        :key="key"
        :label="value[config.label]"
        :value="config.objectReturn ? value : value[config.primarykey]"
      ></el-option>
    </el-select>

    <select-autocomplete
      v-if="type === 'select' && ! config.hasOwnProperty('items') "
      :placeholder="config.placeholder"
      :primary-key="config.primarykey"
      :url-search="config.urlSearch"
      :label="config.label"
      :object-return="config.objectReturn"
      @input="$emit('input', $event)"
    ></select-autocomplete>

  </div>
</template>

<script>
import SelectAutocomplete from '@/Components/SelectAutocomplete.vue'

export default {
  components: { SelectAutocomplete },
  name: 'Field',
  props: ['type', 'config'],
  data() {
    return {
      form: {}
    }
  }
}
</script>

<style>
</style>
